module.exports = __webpack_public_path__ + "static/media/menu-3.c69df82c.png";